import { render, staticRenderFns } from "./TransferConfirm.vue?vue&type=template&id=1072bab0&scoped=true&"
import script from "./TransferConfirm.vue?vue&type=script&lang=ts&"
export * from "./TransferConfirm.vue?vue&type=script&lang=ts&"
import style0 from "./TransferConfirm.vue?vue&type=style&index=0&id=1072bab0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1072bab0",
  null
  
)

export default component.exports